import { render, staticRenderFns } from "./CallHistoryView.vue?vue&type=template&id=ea155c1a&"
import script from "./CallHistoryView.vue?vue&type=script&lang=js&"
export * from "./CallHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports